// Logic handles setting the active list item in the key takeaways list
const KeyTakeaways = () => {
  const $ul = document.querySelector('.ar-key-takeaways-list');
  const $lis = $ul.querySelectorAll('li a');
  
  function updateActiveLink(event) {
    const el = event.target;
    $lis.forEach((li) => {
      li.classList = '';
    });
    if (el.tagName === 'LI') {
      const $a = el.find('a');
      $a.classList.add('active');
    } else if (el.tagName === 'A') {
      el.classList.add('active');
    }
  }

  $ul.addEventListener('click', updateActiveLink);
};
